import React, {Component} from 'react';
import DriverDetails from "./DriverDetails";
import PolicyDetails from "./PolicyDetails";
import PolicyHolder from "./PolicyHolder";
import DirectDebit from "./DirectDebit";
import PaymentSuccess from "./PaymentSuccess";
import SessionExpirePopup from "./SessionExpirePopup";
import PaymentFailure from "./PaymentFailure";
import CarDetails from "./CarDetails";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import RecaptchaPopup from "./common/recaptchapopup";

class MultiStepFormCAR extends Component {
  state = {
    step: 1,
    sessionTimeout: 1800,
    showCookieExpiryPopup: false,
    expireSession: false,
    showDisclaimer: true,
    declarationPopupShow: false,
    mainDriverDetailsSwitchEnabled: false,
    addressSwitchEnabled: false,
    uniqueAddressFound: false,
    postalUniqueAddressFound: false,
    transmissionType: '',
    regNumber: '',
    vehicleKey: '',
    vehicleModel: '',
    vehicleValue: '',
    financeCompany: '',
    riskAddressId: '',
    riskPostcode: '',
    riskSignature: '',
    riskSuburb: '',
    riskBuildingName: '',
    riskLevelNumber: '',
    riskLevelType: '',
    riskStreetName: '',
    riskStreetNumber: '',
    riskStreetSuffixCode: '',
    riskStreetType: '',
    riskUnitNumber: '',
    riskUnitType: '',
    riskAddressLine1: '',
    riskAddressLine2: '',
    showRecaptchaPopup: false,
    isRecaptchaV2Verified: false,
    driverList: {
      driver1: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        type: 'Primary',
        incidentCount: '',
        incidentList: {
          incidents1: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents2: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents3: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents4: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          }
        }
      },
      driver2: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        type: 'Driver2',
        incidentCount: '',
        incidentList: {
          incidents1: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents2: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents3: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents4: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          }
        }
      },
      driver3: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        type: 'Driver3',
        incidentCount: '',
        incidentList: {
          incidents1: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents2: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents3: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents4: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          }
        }
      },
      driver4: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        type: 'Driver4',
        incidentCount: '',
        incidentList: {
          incidents1: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents2: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents3: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents4: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          }
        }
      },
      driver5: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        type: 'Driver5',
        incidentCount: '',
        incidentList: {
          incidents1: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents2: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents3: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          },
          incidents4: {
            claimCode: '',
            claimMonth: '',
            claimYear: ''
          }
        }
      }

    },
    postalAddress: {
      fullAddress: '',
      addressId: '',
      postcode: '',
      signature: '',
      suburb: '',
      buildingName: '',
      levelNumber: '',
      levelType: '',
      streetName: '',
      streetNumber: '',
      streetSuffixCode: '',
      streetType: '',
      unitNumber: '',
      unitType: '',
      addressLine1: '',
      addressLine2: '',
    },
    driverLength: 1,
    policyHolderLength: 1,
    excessFreeWindow: false,
    roadSideAssistance: false,
    hireCar: false,
    responseJson: {},
    responseCreatedTime: '',
    excess: 300,
    vehicleMinValue: 0,
    vehicleMaxValue: 0,
    paymentFrequency: 'FORTNIGHTLY',
    insuranceCover: 'COMPREHENSIVE',
    premium: '',
    accountName: '',
    accountNumber: '',
    accountAuthorizer: '',
    paymentStartDate: null,
    paymentMethod: '',
    agreeToDirectTerms: false,
    policyHolderList: {
      policyHolder1: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        title: '',
        mobileCode: '021',
        mobile: '',
        email: '',
      },
      policyHolder2: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        title: '',
        mobileCode: '021',
        mobile: '',
        email: '',
      },
      policyHolder3: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        title: '',
        mobileCode: '021',
        mobile: '',
        email: '',
      },
      policyHolder4: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        title: '',
        mobileCode: '021',
        mobile: '',
        email: '',
      },
      policyHolder5: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        title: '',
        mobileCode: '021',
        mobile: '',
        email: '',
      }
    },
    policyNumber: '',
    quoteNumber: '',
    directDebitTermAccepted: false,
    modification: null,
    businessUse: null,
    isFinanced: null,
    isCriminalRecord: null,
    taxiExclusion: null,
    policyStartDate: null,
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    jointFirstName: '',
    jointLastName: '',
    jointDateOfBirth: '',

    joint: false,
    email: '',
    phone: '',
    mobile: '',
    full_address: '',
    addressLine1: '',
    addressLine2: '',
    suburb: '',
    city: '',
    postcode: '',
    benefits: null,
    quote: null,
    amendQuoteResponse: null,
    vehicleInputValue: '',
    vehicleInputOdometerValue: '',
    exclusions: null,
    transmissionOptions: [],
    modelList: [],
    applicantType: 'Private',
    businessName: '',
    selectedTermAndCover: null,
    variant: null,
    id: ''
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.sessionTimeout !== this.state.sessionTimeout) {
      setTimeout(() => {
        this.handleChangeValue('showCookieExpiryPopup', false);
        if (this.state.expireSession) {
          window.location.href = '/vehicle/session-expired';
        }
      }, this.state.sessionTimeout * 1000);
      setTimeout(() => {
        this.handleChangeValue('expireSession', true);
        // clearTimeout(timer);
        this.handleChangeValue('showCookieExpiryPopup', true);
      }, this.state.sessionTimeout * 1000 - (120 * 1000));


    }
  }

  nextStep = () => {
    const {step} = this.state
    this.setState({
      step: step + 1
    })
  }
  paymentFailure = () => {
    const {step} = this.state
    this.setState({
      step: step + 2
    })
  }
  policyHolderStep = () => {
    const {step} = this.state
    this.setState({
      step: step + 3
    })
  }
  FirstStepQuote = () => {
    this.setState({
      step: 2
    })
  }
  directDebitPage = () => {
    const {step} = this.state
    this.setState({
      step: step - 2
    })
  }
  prevStep = () => {
    const {step} = this.state
    this.setState({
      step: step - 1
    })
  }

  handleUpdateJson = (event) => {
    const {name, value} = event.target;
    this.updateDriver(name, value);
  }


  updateDriver = (name, value) => {
    const [driverKey, nestedKey1, nestedKey2, nestedKey3] = name.split(".");

    this.setState(prevState => {
      const updatedDriverList = {...prevState.driverList};
      const driver = {...updatedDriverList[driverKey]};

      if (nestedKey1 === "incidentList") {
        const incidentList = {...driver.incidentList};
        const incident = {...incidentList[nestedKey2]};
        incident[nestedKey3] = value;
        incidentList[nestedKey2] = incident;
        driver.incidentList = incidentList;
      } else {
        driver[nestedKey1] = value;
      }

      updatedDriverList[driverKey] = driver;
      return {driverList: updatedDriverList};
    });

  }

  updatePostalAddress = (name, value) => {
    const [key, nestedKey1] = name.split(".");
    this.setState(prevState => {
      const postalAddr = {...prevState.postalAddress};
      postalAddr[nestedKey1] = value;
      return {postalAddress: postalAddr}
    });

  }

  handleUpdatePolicyHolderJson = (event) => {
    const {name, value} = event.target;
    const [policyHolderKey, nestedKey1] = name.split(".");

    this.setState(prevState => {
      const updatedPolicyHolderKeyList = {...prevState.policyHolderList};
      const policyHolder = {...updatedPolicyHolderKeyList[policyHolderKey]};

      policyHolder[nestedKey1] = value;

      updatedPolicyHolderKeyList[policyHolderKey] = policyHolder;

      return {policyHolderList: updatedPolicyHolderKeyList};
    });
  }

  setPolicyHolderJson = (name, value) => {
    const [policyHolderKey, nestedKey1] = name.split(".");

    this.setState(prevState => {
      const updatedPolicyHolderKeyList = {...prevState.policyHolderList};
      const policyHolder = {...updatedPolicyHolderKeyList[policyHolderKey]};

      policyHolder[nestedKey1] = value;

      updatedPolicyHolderKeyList[policyHolderKey] = policyHolder;

      return {policyHolderList: updatedPolicyHolderKeyList};
    });
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value})

  }

  handleChangeValue = (name, value) => {
    this.setState({[name]: value})
  }

  render() {
    const {
      sessionTimeout,
      showCookieExpiryPopup,
      expireSession,
      showDisclaimer,
      declarationPopupShow,
      mainDriverDetailsSwitchEnabled,
      addressSwitchEnabled,
      uniqueAddressFound,
      postalUniqueAddressFound,
      transmissionType,
      regNumber,
      vehicleKey,
      vehicleModel,
      vehicleValue,
      financeCompany,
      riskAddressId,
      riskPostcode,
      riskSignature,
      riskSuburb,
      riskBuildingName,
      riskLevelNumber,
      riskLevelType,
      riskStreetName,
      riskStreetNumber,
      riskStreetSuffixCode,
      riskStreetType,
      riskUnitNumber,
      riskUnitType,
      riskAddressLine1,
      riskAddressLine2,
      driverList,
      driverLength,
      policyHolderLength,
      responseJson,
      excessFreeWindow,
      roadSideAssistance,
      hireCar,
      excess,
      vehicleMinValue,
      vehicleMaxValue,
      paymentFrequency,
      insuranceCover,
      premium,
      accountName,
      accountNumber,
      accountAuthorizer,
      paymentStartDate,
      paymentMethod,
      agreeToDirectTerms,
      policyHolderList,
      policyNumber,
      quoteNumber,
      directDebitTermAccepted,
      postalAddress,

      step,
      benefits,
      quote,
      amendQuoteResponse,
      modification,
      businessUse,
      isFinanced,
      isCriminalRecord,
      firstName,
      lastName,
      dateOfBirth,
      joint,
      jointFirstName,
      jointLastName,
      jointDateOfBirth,
      email,
      phone,
      mobile,
      full_address,
      addressLine1,
      addressLine2,
      suburb,
      city,
      postcode,
      taxiExclusion,
      policyStartDate,
      vehicleInputValue,
      vehicleInputOdometerValue,
      exclusions,
      transmissionOptions,
      modelList,
      applicantType,
      businessName,
      selectedTermAndCover,
      variant,
      id,
      showRecaptchaPopup,
      isRecaptchaV2Verified
    } = this.state;
    const inputValues = {
      sessionTimeout,
      showCookieExpiryPopup,
      expireSession,
      showDisclaimer,
      declarationPopupShow,
      mainDriverDetailsSwitchEnabled,
      addressSwitchEnabled,
      uniqueAddressFound,
      postalUniqueAddressFound,
      transmissionType,
      regNumber,
      vehicleKey,
      vehicleModel,
      vehicleValue,
      financeCompany,
      riskAddressId,
      riskPostcode,
      riskSignature,
      riskSuburb,
      riskBuildingName,
      riskLevelNumber,
      riskLevelType,
      riskStreetName,
      riskStreetNumber,
      riskStreetSuffixCode,
      riskStreetType,
      riskUnitNumber,
      riskUnitType,
      riskAddressLine1,
      riskAddressLine2,
      driverList,
      driverLength,
      policyHolderLength,
      responseJson,
      excessFreeWindow,
      roadSideAssistance,
      hireCar,
      vehicleMinValue,
      vehicleMaxValue,
      paymentFrequency,
      excess,
      insuranceCover,
      premium,
      accountName,
      accountNumber,
      accountAuthorizer,
      paymentStartDate,
      paymentMethod,
      agreeToDirectTerms,
      policyHolderList,
      policyNumber,
      quoteNumber,
      directDebitTermAccepted,
      postalAddress,

      benefits,
      quote,
      amendQuoteResponse,
      modification,
      businessUse,
      isFinanced,
      isCriminalRecord,
      firstName,
      lastName,
      dateOfBirth,
      joint,
      jointFirstName,
      jointLastName,
      jointDateOfBirth,
      email,
      phone,
      mobile,
      full_address,
      addressLine1,
      addressLine2,
      suburb,
      city,
      postcode,
      taxiExclusion,
      policyStartDate,
      vehicleInputValue,
      vehicleInputOdometerValue,
      exclusions,
      transmissionOptions,
      modelList,
      applicantType,
      businessName,
      selectedTermAndCover,
      variant,
      id,
      showRecaptchaPopup,
      isRecaptchaV2Verified
    };

    switch (step) {
      /*case 1:
          return <>
          <Disclaimer
              nextStep={this.nextStep}
          />
              <br/><br/>
          </>*/
      case 1:
        return <>
          <RecaptchaPopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}
          />
          <SessionExpirePopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}/>
          <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
            <CarDetails
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              handleChangeValue={this.handleChangeValue}
              inputValues={inputValues}
              updatePostalAddress={this.updatePostalAddress}
              policyHolderStep={this.policyHolderStep}
            />
          </GoogleReCaptchaProvider>
          <br/><br/>
        </>
      case 2:
        return <>
          <RecaptchaPopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}
          />
          <SessionExpirePopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}/>
          <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
            <DriverDetails
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              prevStep={this.prevStep}
              handleChangeValue={this.handleChangeValue}
              inputValues={inputValues}
              handleUpdateJson={this.handleUpdateJson}
              updateDriver={this.updateDriver}
            />
          </GoogleReCaptchaProvider>
          <br/><br/>
        </>
      case 3:
        return <>
          <RecaptchaPopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}
          />
          <SessionExpirePopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}/>
          <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
            <PolicyDetails
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              prevStep={this.prevStep}
              handleChangeValue={this.handleChangeValue}
              inputValues={inputValues}
              handleUpdateJson={this.handleUpdateJson}
              updatePostalAddress={this.updatePostalAddress}
            />
          </GoogleReCaptchaProvider>
          <br/><br/>
        </>
      case 4:
        return <>
          <RecaptchaPopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}
          />
          <SessionExpirePopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}/>
          <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
            <PolicyHolder
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              prevStep={this.prevStep}
              handleChangeValue={this.handleChangeValue}
              inputValues={inputValues}
              handleUpdatePolicyHolderJson={this.handleUpdatePolicyHolderJson}
              setPolicyHolderJson={this.setPolicyHolderJson}
              updatePostalAddress={this.updatePostalAddress}
            />
          </GoogleReCaptchaProvider>
          <br/><br/>
        </>
      case 5:
        return <>
          <RecaptchaPopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}
          />
          <SessionExpirePopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}/>
          <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
            <DirectDebit
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              prevStep={this.prevStep}
              handleChangeValue={this.handleChangeValue}
              inputValues={inputValues}
              handleUpdateJson={this.handleUpdateJson}
              paymentFailurePage={this.paymentFailure}
            />
          </GoogleReCaptchaProvider>
          <br/><br/>
        </>
      case 6:
        return <>
          <RecaptchaPopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}
          />
          <SessionExpirePopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}/>
          <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
            <PaymentSuccess
              inputValues={inputValues}
            />
          </GoogleReCaptchaProvider>
          <br/><br/>
        </>
      case 7:
        return <>
          <RecaptchaPopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}
          />
          <SessionExpirePopup
            inputValues={inputValues}
            handleChangeValue={this.handleChangeValue}/>
          <GoogleReCaptchaProvider reCaptchaKey="6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7">
            <PaymentFailure
              inputValues={inputValues}
              directDebitPage={this.directDebitPage}
              FirstStepQuote={this.FirstStepQuote}
            />
          </GoogleReCaptchaProvider>
          <br/><br/>
        </>
    }
  }
}

export default MultiStepFormCAR;
